// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"0ca8a62c","7435":"0ca8a62c","8956":"ddc72746"}[chunkId] + ".chunk.css";
};